import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const QuotaIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  // style="enable-background:new 0 0 512 512;"

  return (
    <svg
      style={style}
      className={className}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path
            d="M315.411,87.082H107.254c-27.019,0-48.999,21.982-48.999,49v326.918c0,27.019,21.981,48.999,48.999,48.999h208.156
			c27.02,0,49-21.981,49-48.999V136.083C364.411,109.064,342.429,87.082,315.411,87.082z M106.221,385.214
			c0-8.297,6.727-15.024,15.024-15.024H300.41c8.297,0,15.024,6.727,15.024,15.024c0,8.297-6.727,15.024-15.024,15.024H121.244
			C112.947,400.238,106.221,393.512,106.221,385.214z M107.041,337.75c0-8.297,6.727-15.024,15.024-15.024h179.165
			c8.297,0,15.024,6.727,15.024,15.024c0,8.297-6.726,15.024-15.023,15.024H122.065C113.768,352.774,107.041,346.047,107.041,337.75
			z M301.23,446.416h-56.413c-8.297,0-15.024-6.727-15.024-15.024c0-8.297,6.727-15.024,15.024-15.024h56.413
			c8.297,0,15.024,6.727,15.024,15.024C316.254,439.689,309.527,446.416,301.23,446.416z M294.509,198.547
			c-0.155,0-0.307-0.009-0.462-0.012l-50.73,50.838c0.093,0.855,0.144,1.724,0.144,2.604c0,13.212-10.749,23.961-23.962,23.961
			c-11.007,0-20.298-7.463-23.095-17.593l-20.866-13.886c-1.202,0.269-2.439,0.444-3.706,0.505l-21.399,24.682
			c0.062,0.67,0.098,1.347,0.098,2.033c0,11.99-9.754,21.744-21.744,21.744c-11.991,0-21.745-9.754-21.745-21.744
			c0-11.636,9.188-21.165,20.691-21.718l21.4-24.683c-0.062-0.67-0.098-1.347-0.098-2.033c0-11.99,9.754-21.744,21.744-21.744
			c10.693,0,19.601,7.76,21.405,17.943l16.654,11.083c3.213-1.604,6.833-2.512,10.662-2.512c0.86,0,1.709,0.048,2.546,0.136
			l50.732-50.841c-0.004-0.169-0.013-0.339-0.013-0.509c0-11.99,9.754-21.744,21.744-21.744c11.991,0,21.745,9.754,21.745,21.744
			S306.499,198.547,294.509,198.547z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M403.357,0H176.414c-27.828,0-50.387,22.559-50.387,50.387v2.704c0,5.018,4.067,9.085,9.085,9.085h208.572
			c27.02,0,49,21.982,49,49l1.586,335.534c0.024,5.001,4.084,9.042,9.085,9.042c27.828,0,50.388-22.559,50.388-50.388V50.388
			C453.744,22.559,431.185,0,403.357,0z"
          />
        </g>
      </g>
    </svg>
  );
};
